(function() {
var n, l$1, u$2, t$1, i$1, r$1, o$1, e$1, f$2, c$1, s$1, a$1, h$1, p$1 = {}, v$1 = [], y$1 = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i, w$1 = Array.isArray;
function d$1(n2, l2) {
  for (var u2 in l2) n2[u2] = l2[u2];
  return n2;
}
function g$1(n2) {
  n2 && n2.parentNode && n2.parentNode.removeChild(n2);
}
function _$1(l2, u2, t2) {
  var i2, r2, o2, e2 = {};
  for (o2 in u2) "key" == o2 ? i2 = u2[o2] : "ref" == o2 ? r2 = u2[o2] : e2[o2] = u2[o2];
  if (arguments.length > 2 && (e2.children = arguments.length > 3 ? n.call(arguments, 2) : t2), "function" == typeof l2 && null != l2.defaultProps) for (o2 in l2.defaultProps) void 0 === e2[o2] && (e2[o2] = l2.defaultProps[o2]);
  return m$1(l2, e2, i2, r2, null);
}
function m$1(n2, t2, i2, r2, o2) {
  var e2 = { type: n2, props: t2, key: i2, ref: r2, __k: null, __: null, __b: 0, __e: null, __c: null, constructor: void 0, __v: null == o2 ? ++u$2 : o2, __i: -1, __u: 0 };
  return null == o2 && null != l$1.vnode && l$1.vnode(e2), e2;
}
function k$1(n2) {
  return n2.children;
}
function x$1(n2, l2) {
  this.props = n2, this.context = l2;
}
function S(n2, l2) {
  if (null == l2) return n2.__ ? S(n2.__, n2.__i + 1) : null;
  for (var u2; l2 < n2.__k.length; l2++) if (null != (u2 = n2.__k[l2]) && null != u2.__e) return u2.__e;
  return "function" == typeof n2.type ? S(n2) : null;
}
function C$1(n2) {
  var l2, u2;
  if (null != (n2 = n2.__) && null != n2.__c) {
    for (n2.__e = n2.__c.base = null, l2 = 0; l2 < n2.__k.length; l2++) if (null != (u2 = n2.__k[l2]) && null != u2.__e) {
      n2.__e = n2.__c.base = u2.__e;
      break;
    }
    return C$1(n2);
  }
}
function M(n2) {
  (!n2.__d && (n2.__d = true) && i$1.push(n2) && !$.__r++ || r$1 != l$1.debounceRendering) && ((r$1 = l$1.debounceRendering) || o$1)($);
}
function $() {
  for (var n2, u2, t2, r2, o2, f2, c2, s2 = 1; i$1.length; ) i$1.length > s2 && i$1.sort(e$1), n2 = i$1.shift(), s2 = i$1.length, n2.__d && (t2 = void 0, o2 = (r2 = (u2 = n2).__v).__e, f2 = [], c2 = [], u2.__P && ((t2 = d$1({}, r2)).__v = r2.__v + 1, l$1.vnode && l$1.vnode(t2), O(u2.__P, t2, r2, u2.__n, u2.__P.namespaceURI, 32 & r2.__u ? [o2] : null, f2, null == o2 ? S(r2) : o2, !!(32 & r2.__u), c2), t2.__v = r2.__v, t2.__.__k[t2.__i] = t2, N(f2, t2, c2), t2.__e != o2 && C$1(t2)));
  $.__r = 0;
}
function I(n2, l2, u2, t2, i2, r2, o2, e2, f2, c2, s2) {
  var a2, h2, y2, w2, d2, g2, _2, m2 = t2 && t2.__k || v$1, b = l2.length;
  for (f2 = P(u2, l2, m2, f2, b), a2 = 0; a2 < b; a2++) null != (y2 = u2.__k[a2]) && (h2 = -1 == y2.__i ? p$1 : m2[y2.__i] || p$1, y2.__i = a2, g2 = O(n2, y2, h2, i2, r2, o2, e2, f2, c2, s2), w2 = y2.__e, y2.ref && h2.ref != y2.ref && (h2.ref && B$1(h2.ref, null, y2), s2.push(y2.ref, y2.__c || w2, y2)), null == d2 && null != w2 && (d2 = w2), (_2 = !!(4 & y2.__u)) || h2.__k === y2.__k ? f2 = A$1(y2, f2, n2, _2) : "function" == typeof y2.type && void 0 !== g2 ? f2 = g2 : w2 && (f2 = w2.nextSibling), y2.__u &= -7);
  return u2.__e = d2, f2;
}
function P(n2, l2, u2, t2, i2) {
  var r2, o2, e2, f2, c2, s2 = u2.length, a2 = s2, h2 = 0;
  for (n2.__k = new Array(i2), r2 = 0; r2 < i2; r2++) null != (o2 = l2[r2]) && "boolean" != typeof o2 && "function" != typeof o2 ? (f2 = r2 + h2, (o2 = n2.__k[r2] = "string" == typeof o2 || "number" == typeof o2 || "bigint" == typeof o2 || o2.constructor == String ? m$1(null, o2, null, null, null) : w$1(o2) ? m$1(k$1, { children: o2 }, null, null, null) : null == o2.constructor && o2.__b > 0 ? m$1(o2.type, o2.props, o2.key, o2.ref ? o2.ref : null, o2.__v) : o2).__ = n2, o2.__b = n2.__b + 1, e2 = null, -1 != (c2 = o2.__i = L(o2, u2, f2, a2)) && (a2--, (e2 = u2[c2]) && (e2.__u |= 2)), null == e2 || null == e2.__v ? (-1 == c2 && (i2 > s2 ? h2-- : i2 < s2 && h2++), "function" != typeof o2.type && (o2.__u |= 4)) : c2 != f2 && (c2 == f2 - 1 ? h2-- : c2 == f2 + 1 ? h2++ : (c2 > f2 ? h2-- : h2++, o2.__u |= 4))) : n2.__k[r2] = null;
  if (a2) for (r2 = 0; r2 < s2; r2++) null != (e2 = u2[r2]) && 0 == (2 & e2.__u) && (e2.__e == t2 && (t2 = S(e2)), D$1(e2, e2));
  return t2;
}
function A$1(n2, l2, u2, t2) {
  var i2, r2;
  if ("function" == typeof n2.type) {
    for (i2 = n2.__k, r2 = 0; i2 && r2 < i2.length; r2++) i2[r2] && (i2[r2].__ = n2, l2 = A$1(i2[r2], l2, u2, t2));
    return l2;
  }
  n2.__e != l2 && (t2 && (l2 && n2.type && !l2.parentNode && (l2 = S(n2)), u2.insertBefore(n2.__e, l2 || null)), l2 = n2.__e);
  do {
    l2 = l2 && l2.nextSibling;
  } while (null != l2 && 8 == l2.nodeType);
  return l2;
}
function L(n2, l2, u2, t2) {
  var i2, r2, o2, e2 = n2.key, f2 = n2.type, c2 = l2[u2], s2 = null != c2 && 0 == (2 & c2.__u);
  if (null === c2 && null == n2.key || s2 && e2 == c2.key && f2 == c2.type) return u2;
  if (t2 > (s2 ? 1 : 0)) {
    for (i2 = u2 - 1, r2 = u2 + 1; i2 >= 0 || r2 < l2.length; ) if (null != (c2 = l2[o2 = i2 >= 0 ? i2-- : r2++]) && 0 == (2 & c2.__u) && e2 == c2.key && f2 == c2.type) return o2;
  }
  return -1;
}
function T$1(n2, l2, u2) {
  "-" == l2[0] ? n2.setProperty(l2, null == u2 ? "" : u2) : n2[l2] = null == u2 ? "" : "number" != typeof u2 || y$1.test(l2) ? u2 : u2 + "px";
}
function j$1(n2, l2, u2, t2, i2) {
  var r2, o2;
  n: if ("style" == l2) if ("string" == typeof u2) n2.style.cssText = u2;
  else {
    if ("string" == typeof t2 && (n2.style.cssText = t2 = ""), t2) for (l2 in t2) u2 && l2 in u2 || T$1(n2.style, l2, "");
    if (u2) for (l2 in u2) t2 && u2[l2] == t2[l2] || T$1(n2.style, l2, u2[l2]);
  }
  else if ("o" == l2[0] && "n" == l2[1]) r2 = l2 != (l2 = l2.replace(f$2, "$1")), o2 = l2.toLowerCase(), l2 = o2 in n2 || "onFocusOut" == l2 || "onFocusIn" == l2 ? o2.slice(2) : l2.slice(2), n2.l || (n2.l = {}), n2.l[l2 + r2] = u2, u2 ? t2 ? u2.u = t2.u : (u2.u = c$1, n2.addEventListener(l2, r2 ? a$1 : s$1, r2)) : n2.removeEventListener(l2, r2 ? a$1 : s$1, r2);
  else {
    if ("http://www.w3.org/2000/svg" == i2) l2 = l2.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
    else if ("width" != l2 && "height" != l2 && "href" != l2 && "list" != l2 && "form" != l2 && "tabIndex" != l2 && "download" != l2 && "rowSpan" != l2 && "colSpan" != l2 && "role" != l2 && "popover" != l2 && l2 in n2) try {
      n2[l2] = null == u2 ? "" : u2;
      break n;
    } catch (n3) {
    }
    "function" == typeof u2 || (null == u2 || false === u2 && "-" != l2[4] ? n2.removeAttribute(l2) : n2.setAttribute(l2, "popover" == l2 && 1 == u2 ? "" : u2));
  }
}
function F(n2) {
  return function(u2) {
    if (this.l) {
      var t2 = this.l[u2.type + n2];
      if (null == u2.t) u2.t = c$1++;
      else if (u2.t < t2.u) return;
      return t2(l$1.event ? l$1.event(u2) : u2);
    }
  };
}
function O(n2, u2, t2, i2, r2, o2, e2, f2, c2, s2) {
  var a2, h2, p2, v2, y2, _2, m2, b, S2, C2, M2, $2, P2, A2, H, L2, T2, j2 = u2.type;
  if (null != u2.constructor) return null;
  128 & t2.__u && (c2 = !!(32 & t2.__u), o2 = [f2 = u2.__e = t2.__e]), (a2 = l$1.__b) && a2(u2);
  n: if ("function" == typeof j2) try {
    if (b = u2.props, S2 = "prototype" in j2 && j2.prototype.render, C2 = (a2 = j2.contextType) && i2[a2.__c], M2 = a2 ? C2 ? C2.props.value : a2.__ : i2, t2.__c ? m2 = (h2 = u2.__c = t2.__c).__ = h2.__E : (S2 ? u2.__c = h2 = new j2(b, M2) : (u2.__c = h2 = new x$1(b, M2), h2.constructor = j2, h2.render = E), C2 && C2.sub(h2), h2.props = b, h2.state || (h2.state = {}), h2.context = M2, h2.__n = i2, p2 = h2.__d = true, h2.__h = [], h2._sb = []), S2 && null == h2.__s && (h2.__s = h2.state), S2 && null != j2.getDerivedStateFromProps && (h2.__s == h2.state && (h2.__s = d$1({}, h2.__s)), d$1(h2.__s, j2.getDerivedStateFromProps(b, h2.__s))), v2 = h2.props, y2 = h2.state, h2.__v = u2, p2) S2 && null == j2.getDerivedStateFromProps && null != h2.componentWillMount && h2.componentWillMount(), S2 && null != h2.componentDidMount && h2.__h.push(h2.componentDidMount);
    else {
      if (S2 && null == j2.getDerivedStateFromProps && b !== v2 && null != h2.componentWillReceiveProps && h2.componentWillReceiveProps(b, M2), !h2.__e && null != h2.shouldComponentUpdate && false === h2.shouldComponentUpdate(b, h2.__s, M2) || u2.__v == t2.__v) {
        for (u2.__v != t2.__v && (h2.props = b, h2.state = h2.__s, h2.__d = false), u2.__e = t2.__e, u2.__k = t2.__k, u2.__k.some(function(n3) {
          n3 && (n3.__ = u2);
        }), $2 = 0; $2 < h2._sb.length; $2++) h2.__h.push(h2._sb[$2]);
        h2._sb = [], h2.__h.length && e2.push(h2);
        break n;
      }
      null != h2.componentWillUpdate && h2.componentWillUpdate(b, h2.__s, M2), S2 && null != h2.componentDidUpdate && h2.__h.push(function() {
        h2.componentDidUpdate(v2, y2, _2);
      });
    }
    if (h2.context = M2, h2.props = b, h2.__P = n2, h2.__e = false, P2 = l$1.__r, A2 = 0, S2) {
      for (h2.state = h2.__s, h2.__d = false, P2 && P2(u2), a2 = h2.render(h2.props, h2.state, h2.context), H = 0; H < h2._sb.length; H++) h2.__h.push(h2._sb[H]);
      h2._sb = [];
    } else do {
      h2.__d = false, P2 && P2(u2), a2 = h2.render(h2.props, h2.state, h2.context), h2.state = h2.__s;
    } while (h2.__d && ++A2 < 25);
    h2.state = h2.__s, null != h2.getChildContext && (i2 = d$1(d$1({}, i2), h2.getChildContext())), S2 && !p2 && null != h2.getSnapshotBeforeUpdate && (_2 = h2.getSnapshotBeforeUpdate(v2, y2)), L2 = a2, null != a2 && a2.type === k$1 && null == a2.key && (L2 = V(a2.props.children)), f2 = I(n2, w$1(L2) ? L2 : [L2], u2, t2, i2, r2, o2, e2, f2, c2, s2), h2.base = u2.__e, u2.__u &= -161, h2.__h.length && e2.push(h2), m2 && (h2.__E = h2.__ = null);
  } catch (n3) {
    if (u2.__v = null, c2 || null != o2) if (n3.then) {
      for (u2.__u |= c2 ? 160 : 128; f2 && 8 == f2.nodeType && f2.nextSibling; ) f2 = f2.nextSibling;
      o2[o2.indexOf(f2)] = null, u2.__e = f2;
    } else {
      for (T2 = o2.length; T2--; ) g$1(o2[T2]);
      z$1(u2);
    }
    else u2.__e = t2.__e, u2.__k = t2.__k, n3.then || z$1(u2);
    l$1.__e(n3, u2, t2);
  }
  else null == o2 && u2.__v == t2.__v ? (u2.__k = t2.__k, u2.__e = t2.__e) : f2 = u2.__e = q(t2.__e, u2, t2, i2, r2, o2, e2, c2, s2);
  return (a2 = l$1.diffed) && a2(u2), 128 & u2.__u ? void 0 : f2;
}
function z$1(n2) {
  n2 && n2.__c && (n2.__c.__e = true), n2 && n2.__k && n2.__k.forEach(z$1);
}
function N(n2, u2, t2) {
  for (var i2 = 0; i2 < t2.length; i2++) B$1(t2[i2], t2[++i2], t2[++i2]);
  l$1.__c && l$1.__c(u2, n2), n2.some(function(u3) {
    try {
      n2 = u3.__h, u3.__h = [], n2.some(function(n3) {
        n3.call(u3);
      });
    } catch (n3) {
      l$1.__e(n3, u3.__v);
    }
  });
}
function V(n2) {
  return "object" != typeof n2 || null == n2 || n2.__b && n2.__b > 0 ? n2 : w$1(n2) ? n2.map(V) : d$1({}, n2);
}
function q(u2, t2, i2, r2, o2, e2, f2, c2, s2) {
  var a2, h2, v2, y2, d2, _2, m2, b = i2.props, k2 = t2.props, x2 = t2.type;
  if ("svg" == x2 ? o2 = "http://www.w3.org/2000/svg" : "math" == x2 ? o2 = "http://www.w3.org/1998/Math/MathML" : o2 || (o2 = "http://www.w3.org/1999/xhtml"), null != e2) {
    for (a2 = 0; a2 < e2.length; a2++) if ((d2 = e2[a2]) && "setAttribute" in d2 == !!x2 && (x2 ? d2.localName == x2 : 3 == d2.nodeType)) {
      u2 = d2, e2[a2] = null;
      break;
    }
  }
  if (null == u2) {
    if (null == x2) return document.createTextNode(k2);
    u2 = document.createElementNS(o2, x2, k2.is && k2), c2 && (l$1.__m && l$1.__m(t2, e2), c2 = false), e2 = null;
  }
  if (null == x2) b === k2 || c2 && u2.data == k2 || (u2.data = k2);
  else {
    if (e2 = e2 && n.call(u2.childNodes), b = i2.props || p$1, !c2 && null != e2) for (b = {}, a2 = 0; a2 < u2.attributes.length; a2++) b[(d2 = u2.attributes[a2]).name] = d2.value;
    for (a2 in b) if (d2 = b[a2], "children" == a2) ;
    else if ("dangerouslySetInnerHTML" == a2) v2 = d2;
    else if (!(a2 in k2)) {
      if ("value" == a2 && "defaultValue" in k2 || "checked" == a2 && "defaultChecked" in k2) continue;
      j$1(u2, a2, null, d2, o2);
    }
    for (a2 in k2) d2 = k2[a2], "children" == a2 ? y2 = d2 : "dangerouslySetInnerHTML" == a2 ? h2 = d2 : "value" == a2 ? _2 = d2 : "checked" == a2 ? m2 = d2 : c2 && "function" != typeof d2 || b[a2] === d2 || j$1(u2, a2, d2, b[a2], o2);
    if (h2) c2 || v2 && (h2.__html == v2.__html || h2.__html == u2.innerHTML) || (u2.innerHTML = h2.__html), t2.__k = [];
    else if (v2 && (u2.innerHTML = ""), I("template" == t2.type ? u2.content : u2, w$1(y2) ? y2 : [y2], t2, i2, r2, "foreignObject" == x2 ? "http://www.w3.org/1999/xhtml" : o2, e2, f2, e2 ? e2[0] : i2.__k && S(i2, 0), c2, s2), null != e2) for (a2 = e2.length; a2--; ) g$1(e2[a2]);
    c2 || (a2 = "value", "progress" == x2 && null == _2 ? u2.removeAttribute("value") : null != _2 && (_2 !== u2[a2] || "progress" == x2 && !_2 || "option" == x2 && _2 != b[a2]) && j$1(u2, a2, _2, b[a2], o2), a2 = "checked", null != m2 && m2 != u2[a2] && j$1(u2, a2, m2, b[a2], o2));
  }
  return u2;
}
function B$1(n2, u2, t2) {
  try {
    if ("function" == typeof n2) {
      var i2 = "function" == typeof n2.__u;
      i2 && n2.__u(), i2 && null == u2 || (n2.__u = n2(u2));
    } else n2.current = u2;
  } catch (n3) {
    l$1.__e(n3, t2);
  }
}
function D$1(n2, u2, t2) {
  var i2, r2;
  if (l$1.unmount && l$1.unmount(n2), (i2 = n2.ref) && (i2.current && i2.current != n2.__e || B$1(i2, null, u2)), null != (i2 = n2.__c)) {
    if (i2.componentWillUnmount) try {
      i2.componentWillUnmount();
    } catch (n3) {
      l$1.__e(n3, u2);
    }
    i2.base = i2.__P = null;
  }
  if (i2 = n2.__k) for (r2 = 0; r2 < i2.length; r2++) i2[r2] && D$1(i2[r2], u2, t2 || "function" != typeof n2.type);
  t2 || g$1(n2.__e), n2.__c = n2.__ = n2.__e = void 0;
}
function E(n2, l2, u2) {
  return this.constructor(n2, u2);
}
function G(u2, t2, i2) {
  var r2, o2, e2, f2;
  t2 == document && (t2 = document.documentElement), l$1.__ && l$1.__(u2, t2), o2 = (r2 = false) ? null : t2.__k, e2 = [], f2 = [], O(t2, u2 = t2.__k = _$1(k$1, null, [u2]), o2 || p$1, p$1, t2.namespaceURI, o2 ? null : t2.firstChild ? n.call(t2.childNodes) : null, e2, o2 ? o2.__e : t2.firstChild, r2, f2), N(e2, u2, f2);
}
function K(l2, u2, t2) {
  var i2, r2, o2, e2, f2 = d$1({}, l2.props);
  for (o2 in l2.type && l2.type.defaultProps && (e2 = l2.type.defaultProps), u2) "key" == o2 ? i2 = u2[o2] : "ref" == o2 ? r2 = u2[o2] : f2[o2] = void 0 === u2[o2] && null != e2 ? e2[o2] : u2[o2];
  return arguments.length > 2 && (f2.children = arguments.length > 3 ? n.call(arguments, 2) : t2), m$1(l2.type, f2, i2 || l2.key, r2 || l2.ref, null);
}
function Q(n2) {
  function l2(n3) {
    var u2, t2;
    return this.getChildContext || (u2 = /* @__PURE__ */ new Set(), (t2 = {})[l2.__c] = this, this.getChildContext = function() {
      return t2;
    }, this.componentWillUnmount = function() {
      u2 = null;
    }, this.shouldComponentUpdate = function(n4) {
      this.props.value != n4.value && u2.forEach(function(n5) {
        n5.__e = true, M(n5);
      });
    }, this.sub = function(n4) {
      u2.add(n4);
      var l3 = n4.componentWillUnmount;
      n4.componentWillUnmount = function() {
        u2 && u2.delete(n4), l3 && l3.call(n4);
      };
    }), n3.children;
  }
  return l2.__c = "__cC" + h$1++, l2.__ = n2, l2.Provider = l2.__l = (l2.Consumer = function(n3, l3) {
    return n3.children(l3);
  }).contextType = l2, l2;
}
n = v$1.slice, l$1 = { __e: function(n2, l2, u2, t2) {
  for (var i2, r2, o2; l2 = l2.__; ) if ((i2 = l2.__c) && !i2.__) try {
    if ((r2 = i2.constructor) && null != r2.getDerivedStateFromError && (i2.setState(r2.getDerivedStateFromError(n2)), o2 = i2.__d), null != i2.componentDidCatch && (i2.componentDidCatch(n2, t2 || {}), o2 = i2.__d), o2) return i2.__E = i2;
  } catch (l3) {
    n2 = l3;
  }
  throw n2;
} }, u$2 = 0, t$1 = function(n2) {
  return null != n2 && null == n2.constructor;
}, x$1.prototype.setState = function(n2, l2) {
  var u2;
  u2 = null != this.__s && this.__s != this.state ? this.__s : this.__s = d$1({}, this.state), "function" == typeof n2 && (n2 = n2(d$1({}, u2), this.props)), n2 && d$1(u2, n2), null != n2 && this.__v && (l2 && this._sb.push(l2), M(this));
}, x$1.prototype.forceUpdate = function(n2) {
  this.__v && (this.__e = true, n2 && this.__h.push(n2), M(this));
}, x$1.prototype.render = k$1, i$1 = [], o$1 = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, e$1 = function(n2, l2) {
  return n2.__v.__b - l2.__v.__b;
}, $.__r = 0, f$2 = /(PointerCapture)$|Capture$/i, c$1 = 0, s$1 = F(false), a$1 = F(true), h$1 = 0;
var f$1 = 0;
function u$1(e2, t2, n2, o2, i2, u2) {
  t2 || (t2 = {});
  var a2, c2, p2 = t2;
  if ("ref" in p2) for (c2 in p2 = {}, t2) "ref" == c2 ? a2 = t2[c2] : p2[c2] = t2[c2];
  var l2 = { type: e2, props: p2, key: n2, ref: a2, __k: null, __: null, __b: 0, __e: null, __c: null, constructor: void 0, __v: --f$1, __i: -1, __u: 0, __source: i2, __self: u2 };
  if ("function" == typeof e2 && (a2 = e2.defaultProps)) for (c2 in a2) void 0 === p2[c2] && (p2[c2] = a2[c2]);
  return l$1.vnode && l$1.vnode(l2), l2;
}
var t, r, u, i, o = 0, f = [], c = l$1, e = c.__b, a = c.__r, v = c.diffed, l = c.__c, m = c.unmount, s = c.__;
function p(n2, t2) {
  c.__h && c.__h(r, n2, o || t2), o = 0;
  var u2 = r.__H || (r.__H = { __: [], __h: [] });
  return n2 >= u2.__.length && u2.__.push({}), u2.__[n2];
}
function d(n2) {
  return o = 1, h(D, n2);
}
function h(n2, u2, i2) {
  var o2 = p(t++, 2);
  if (o2.t = n2, !o2.__c && (o2.__ = [D(void 0, u2), function(n3) {
    var t2 = o2.__N ? o2.__N[0] : o2.__[0], r2 = o2.t(t2, n3);
    t2 !== r2 && (o2.__N = [r2, o2.__[1]], o2.__c.setState({}));
  }], o2.__c = r, !r.__f)) {
    var f2 = function(n3, t2, r2) {
      if (!o2.__c.__H) return true;
      var u3 = o2.__c.__H.__.filter(function(n4) {
        return !!n4.__c;
      });
      if (u3.every(function(n4) {
        return !n4.__N;
      })) return !c2 || c2.call(this, n3, t2, r2);
      var i3 = o2.__c.props !== n3;
      return u3.forEach(function(n4) {
        if (n4.__N) {
          var t3 = n4.__[0];
          n4.__ = n4.__N, n4.__N = void 0, t3 !== n4.__[0] && (i3 = true);
        }
      }), c2 && c2.call(this, n3, t2, r2) || i3;
    };
    r.__f = true;
    var c2 = r.shouldComponentUpdate, e2 = r.componentWillUpdate;
    r.componentWillUpdate = function(n3, t2, r2) {
      if (this.__e) {
        var u3 = c2;
        c2 = void 0, f2(n3, t2, r2), c2 = u3;
      }
      e2 && e2.call(this, n3, t2, r2);
    }, r.shouldComponentUpdate = f2;
  }
  return o2.__N || o2.__;
}
function y(n2, u2) {
  var i2 = p(t++, 3);
  !c.__s && C(i2.__H, u2) && (i2.__ = n2, i2.u = u2, r.__H.__h.push(i2));
}
function _(n2, u2) {
  var i2 = p(t++, 4);
  !c.__s && C(i2.__H, u2) && (i2.__ = n2, i2.u = u2, r.__h.push(i2));
}
function A(n2) {
  return o = 5, T(function() {
    return { current: n2 };
  }, []);
}
function T(n2, r2) {
  var u2 = p(t++, 7);
  return C(u2.__H, r2) && (u2.__ = n2(), u2.__H = r2, u2.__h = n2), u2.__;
}
function x(n2) {
  var u2 = r.context[n2.__c], i2 = p(t++, 9);
  return i2.c = n2, u2 ? (null == i2.__ && (i2.__ = true, u2.sub(r)), u2.props.value) : n2.__;
}
function g() {
  var n2 = p(t++, 11);
  if (!n2.__) {
    for (var u2 = r.__v; null !== u2 && !u2.__m && null !== u2.__; ) u2 = u2.__;
    var i2 = u2.__m || (u2.__m = [0, 0]);
    n2.__ = "P" + i2[0] + "-" + i2[1]++;
  }
  return n2.__;
}
function j() {
  for (var n2; n2 = f.shift(); ) if (n2.__P && n2.__H) try {
    n2.__H.__h.forEach(z), n2.__H.__h.forEach(B), n2.__H.__h = [];
  } catch (t2) {
    n2.__H.__h = [], c.__e(t2, n2.__v);
  }
}
c.__b = function(n2) {
  r = null, e && e(n2);
}, c.__ = function(n2, t2) {
  n2 && t2.__k && t2.__k.__m && (n2.__m = t2.__k.__m), s && s(n2, t2);
}, c.__r = function(n2) {
  a && a(n2), t = 0;
  var i2 = (r = n2.__c).__H;
  i2 && (u === r ? (i2.__h = [], r.__h = [], i2.__.forEach(function(n3) {
    n3.__N && (n3.__ = n3.__N), n3.u = n3.__N = void 0;
  })) : (i2.__h.forEach(z), i2.__h.forEach(B), i2.__h = [], t = 0)), u = r;
}, c.diffed = function(n2) {
  v && v(n2);
  var t2 = n2.__c;
  t2 && t2.__H && (t2.__H.__h.length && (1 !== f.push(t2) && i === c.requestAnimationFrame || ((i = c.requestAnimationFrame) || w)(j)), t2.__H.__.forEach(function(n3) {
    n3.u && (n3.__H = n3.u), n3.u = void 0;
  })), u = r = null;
}, c.__c = function(n2, t2) {
  t2.some(function(n3) {
    try {
      n3.__h.forEach(z), n3.__h = n3.__h.filter(function(n4) {
        return !n4.__ || B(n4);
      });
    } catch (r2) {
      t2.some(function(n4) {
        n4.__h && (n4.__h = []);
      }), t2 = [], c.__e(r2, n3.__v);
    }
  }), l && l(n2, t2);
}, c.unmount = function(n2) {
  m && m(n2);
  var t2, r2 = n2.__c;
  r2 && r2.__H && (r2.__H.__.forEach(function(n3) {
    try {
      z(n3);
    } catch (n4) {
      t2 = n4;
    }
  }), r2.__H = void 0, t2 && c.__e(t2, r2.__v));
};
var k = "function" == typeof requestAnimationFrame;
function w(n2) {
  var t2, r2 = function() {
    clearTimeout(u2), k && cancelAnimationFrame(t2), setTimeout(n2);
  }, u2 = setTimeout(r2, 35);
  k && (t2 = requestAnimationFrame(r2));
}
function z(n2) {
  var t2 = r, u2 = n2.__c;
  "function" == typeof u2 && (n2.__c = void 0, u2()), r = t2;
}
function B(n2) {
  var t2 = r;
  n2.__c = n2.__(), r = t2;
}
function C(n2, t2) {
  return !n2 || n2.length !== t2.length || t2.some(function(t3, r2) {
    return t3 !== n2[r2];
  });
}
function D(n2, t2) {
  return "function" == typeof t2 ? t2(n2) : t2;
}
function parse(input, loose) {
  if (input instanceof RegExp) return { keys: false, pattern: input };
  var c2, o2, tmp, ext, keys = [], pattern = "", arr = input.split("/");
  arr[0] || arr.shift();
  while (tmp = arr.shift()) {
    c2 = tmp[0];
    if (c2 === "*") {
      keys.push(c2);
      pattern += tmp[1] === "?" ? "(?:/(.*))?" : "/(.*)";
    } else if (c2 === ":") {
      o2 = tmp.indexOf("?", 1);
      ext = tmp.indexOf(".", 1);
      keys.push(tmp.substring(1, !!~o2 ? o2 : !!~ext ? ext : tmp.length));
      pattern += !!~o2 && !~ext ? "(?:/([^/]+?))?" : "/([^/]+?)";
      if (!!~ext) pattern += (!!~o2 ? "?" : "") + "\\" + tmp.substring(ext);
    } else {
      pattern += "/" + tmp;
    }
  }
  return {
    keys,
    pattern: new RegExp("^" + pattern + (loose ? "(?=$|/)" : "/?$"), "i")
  };
}
const canUseDOM = !!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
function is(x2, y2) {
  return x2 === y2 && (x2 !== 0 || 1 / x2 === 1 / y2) || x2 !== x2 && y2 !== y2;
}
function useSyncExternalStore(subscribe, getSnapshot, getSSRSnapshot) {
  if (getSSRSnapshot && !canUseDOM) getSnapshot = getSSRSnapshot;
  const value = getSnapshot();
  const [{ _instance }, forceUpdate] = d({
    _instance: { _value: value, _getSnapshot: getSnapshot }
  });
  _(() => {
    _instance._value = value;
    _instance._getSnapshot = getSnapshot;
    if (!is(_instance._value, getSnapshot())) {
      forceUpdate({ _instance });
    }
  }, [subscribe, value, getSnapshot]);
  y(() => {
    if (!is(_instance._value, _instance._getSnapshot())) {
      forceUpdate({ _instance });
    }
    return subscribe(() => {
      if (!is(_instance._value, _instance._getSnapshot())) {
        forceUpdate({ _instance });
      }
    });
  }, [subscribe]);
  return value;
}
function forwardRef(component) {
  return component;
}
const useEvent = (fn) => {
  const ref = A([fn, (...args) => ref[0](...args)]).current;
  _(() => {
    ref[0] = fn;
  });
  return ref[1];
};
const eventPopstate = "popstate";
const eventPushState = "pushState";
const eventReplaceState = "replaceState";
const eventHashchange = "hashchange";
const events = [
  eventPopstate,
  eventPushState,
  eventReplaceState,
  eventHashchange
];
const subscribeToLocationUpdates = (callback) => {
  for (const event of events) {
    addEventListener(event, callback);
  }
  return () => {
    for (const event of events) {
      removeEventListener(event, callback);
    }
  };
};
const useLocationProperty = (fn, ssrFn) => useSyncExternalStore(subscribeToLocationUpdates, fn, ssrFn);
const currentSearch = () => location.search;
const useSearch = ({ ssrSearch = "" } = {}) => useLocationProperty(currentSearch, () => ssrSearch);
const currentPathname = () => location.pathname;
const usePathname = ({ ssrPath } = {}) => useLocationProperty(
  currentPathname,
  ssrPath ? () => ssrPath : currentPathname
);
const navigate$1 = (to, { replace = false, state = null } = {}) => history[replace ? eventReplaceState : eventPushState](state, "", to);
const useBrowserLocation = (opts = {}) => [usePathname(opts), navigate$1];
const patchKey = Symbol.for("wouter_v3");
if (typeof history !== "undefined" && typeof window[patchKey] === "undefined") {
  for (const type of [eventPushState, eventReplaceState]) {
    const original = history[type];
    history[type] = function() {
      const result = original.apply(this, arguments);
      const event = new Event(type);
      event.arguments = arguments;
      dispatchEvent(event);
      return result;
    };
  }
  Object.defineProperty(window, patchKey, { value: true });
}
const _relativePath = (base, path) => !path.toLowerCase().indexOf(base.toLowerCase()) ? path.slice(base.length) || "/" : "~" + path;
const baseDefaults = (base = "") => base === "/" ? "" : base;
const absolutePath = (to, base) => to[0] === "~" ? to.slice(1) : baseDefaults(base) + to;
const relativePath = (base = "", path) => _relativePath(unescape(baseDefaults(base)), unescape(path));
const unescape = (str) => {
  try {
    return decodeURI(str);
  } catch (_e) {
    return str;
  }
};
const defaultRouter = {
  hook: useBrowserLocation,
  searchHook: useSearch,
  parser: parse,
  base: "",
  // this option is used to override the current location during SSR
  ssrPath: void 0,
  ssrSearch: void 0,
  // optional context to track render state during SSR
  ssrContext: void 0,
  // customizes how `href` props are transformed for <Link />
  hrefs: (x2) => x2
};
const RouterCtx = Q(defaultRouter);
const useRouter = () => x(RouterCtx);
const Params0 = {}, ParamsCtx = Q(Params0);
const useParams = () => x(ParamsCtx);
const useLocationFromRouter = (router) => {
  const [location2, navigate2] = router.hook(router);
  return [
    relativePath(router.base, location2),
    useEvent((to, navOpts) => navigate2(absolutePath(to, router.base), navOpts))
  ];
};
const useLocation = () => useLocationFromRouter(useRouter());
const matchRoute = (parser, route, path, loose) => {
  const { pattern, keys } = route instanceof RegExp ? { keys: false, pattern: route } : parser(route || "*", loose);
  const result = pattern.exec(path) || [];
  const [$base, ...matches] = result;
  return $base !== void 0 ? [
    true,
    (() => {
      const groups = keys !== false ? Object.fromEntries(keys.map((key, i2) => [key, matches[i2]])) : result.groups;
      let obj = { ...matches };
      groups && Object.assign(obj, groups);
      return obj;
    })(),
    // the third value if only present when parser is in "loose" mode,
    // so that we can extract the base path for nested routes
    ...loose ? [$base] : []
  ] : [false, null];
};
const Router = ({ children, ...props }) => {
  const parent_ = useRouter();
  const parent = props.hook ? defaultRouter : parent_;
  let value = parent;
  const [path, search] = props.ssrPath?.split("?") ?? [];
  if (search) props.ssrSearch = search, props.ssrPath = path;
  props.hrefs = props.hrefs ?? props.hook?.hrefs;
  let ref = A({}), prev = ref.current, next = prev;
  for (let k2 in parent) {
    const option = k2 === "base" ? (
      /* base is special case, it is appended to the parent's base */
      parent[k2] + (props[k2] || "")
    ) : props[k2] || parent[k2];
    if (prev === next && option !== next[k2]) {
      ref.current = next = { ...next };
    }
    next[k2] = option;
    if (option !== parent[k2] || option !== value[k2]) value = next;
  }
  return _$1(RouterCtx.Provider, { value, children });
};
const h_route = ({ children, component }, params) => {
  if (component) return _$1(component, { params });
  return typeof children === "function" ? children(params) : children;
};
const useCachedParams = (value) => {
  let prev = A(Params0);
  const curr = prev.current;
  return prev.current = // Update cache if number of params changed or any value changed
  Object.keys(value).length !== Object.keys(curr).length || Object.entries(value).some(([k2, v2]) => v2 !== curr[k2]) ? value : curr;
};
const Route = ({ path, nest, match, ...renderProps }) => {
  const router = useRouter();
  const [location2] = useLocationFromRouter(router);
  const [matches, routeParams, base] = (
    // `match` is a special prop to give up control to the parent,
    // it is used by the `Switch` to avoid double matching
    match ?? matchRoute(router.parser, path, location2, nest)
  );
  const params = useCachedParams({ ...useParams(), ...routeParams });
  if (!matches) return null;
  const children = base ? _$1(Router, { base }, h_route(renderProps, params)) : h_route(renderProps, params);
  return _$1(ParamsCtx.Provider, { value: params, children });
};
const Link$1 = forwardRef((props, ref) => {
  const router = useRouter();
  const [currentPath, navigate2] = useLocationFromRouter(router);
  const {
    to = "",
    href: targetPath = to,
    onClick: _onClick,
    asChild,
    children,
    className: cls,
    /* eslint-disable no-unused-vars */
    replace,
    state,
    /* eslint-enable no-unused-vars */
    ...restProps
  } = props;
  const onClick = useEvent((event) => {
    if (event.ctrlKey || event.metaKey || event.altKey || event.shiftKey || event.button !== 0)
      return;
    _onClick?.(event);
    if (!event.defaultPrevented) {
      event.preventDefault();
      navigate2(targetPath, props);
    }
  });
  const href = router.hrefs(
    targetPath[0] === "~" ? targetPath.slice(1) : router.base + targetPath,
    router
    // pass router as a second argument for convinience
  );
  return asChild && t$1(children) ? K(children, { onClick, href }) : _$1("a", {
    ...restProps,
    onClick,
    href,
    // `className` can be a function to apply the class if this link is active
    className: cls?.call ? cls(currentPath === targetPath) : cls,
    children,
    ref
  });
});
const flattenChildren = (children) => Array.isArray(children) ? children.flatMap(
  (c2) => flattenChildren(c2 && c2.type === k$1 ? c2.props.children : c2)
) : [children];
const Switch = ({ children, location: location2 }) => {
  const router = useRouter();
  const [originalLocation] = useLocationFromRouter(router);
  for (const element of flattenChildren(children)) {
    let match = 0;
    if (t$1(element) && // we don't require an element to be of type Route,
    // but we do require it to contain a truthy `path` prop.
    // this allows to use different components that wrap Route
    // inside of a switch, for example <AnimatedRoute />.
    (match = matchRoute(
      router.parser,
      element.props.path,
      location2 || originalLocation,
      element.props.nest
    ))[0])
      return K(element, { match });
  }
  return null;
};
const listeners = {
  v: []
};
const onHashChange = () => listeners.v.forEach((cb) => cb());
const subscribeToHashUpdates = (callback) => {
  if (listeners.v.push(callback) === 1)
    addEventListener("hashchange", onHashChange);
  return () => {
    listeners.v = listeners.v.filter((i2) => i2 !== callback);
    if (!listeners.v.length) removeEventListener("hashchange", onHashChange);
  };
};
const currentHashLocation = () => "/" + location.hash.replace(/^#?\/?/, "");
const navigate = (to, { state = null, replace = false } = {}) => {
  const [hash, search] = to.replace(/^#?\/?/, "").split("?");
  const newRelativePath = location.pathname + (search ? `?${search}` : location.search) + `#/${hash}`;
  const oldURL = location.href;
  const newURL = new URL(newRelativePath, location.origin).href;
  if (replace) {
    history.replaceState(state, "", newRelativePath);
  } else {
    history.pushState(state, "", newRelativePath);
  }
  const event = typeof HashChangeEvent !== "undefined" ? new HashChangeEvent("hashchange", { oldURL, newURL }) : new Event("hashchange", { detail: { oldURL, newURL } });
  dispatchEvent(event);
};
const useHashLocation = ({ ssrPath = "/" } = {}) => [
  useSyncExternalStore(
    subscribeToHashUpdates,
    currentHashLocation,
    () => ssrPath
  ),
  navigate
];
useHashLocation.hrefs = (href) => "#" + href;
const AppContext = Q(null);
function AppContextProvider({
  children,
  value
}) {
  return /* @__PURE__ */ u$1(AppContext.Provider, { value, children });
}
function useAppContext() {
  const context = x(AppContext);
  if (context === null) {
    throw new Error("useAppContext must be used within a AppProvider");
  }
  return context;
}
class WidgetError extends Error {
  constructor(message) {
    message = `[x-gsp-products-center]: ${message}`;
    super(message);
    this.name = "WidgetError";
  }
}
function Link({
  href,
  children,
  external,
  rel,
  ...props
}) {
  const _props = props;
  const [, navigate2] = useHashLocation();
  if (external) {
    return /* @__PURE__ */ u$1("a", { href, rel: "noopener noreferrer", ..._props, children });
  }
  return /* @__PURE__ */ u$1(Link$1, { to: href, ..._props, children });
}
function useBreadcrumbs() {
  const { routes } = useAppContext();
  const [location2] = useLocation();
  const result = T(() => {
    const segments = location2.split("/").filter(Boolean).map((_2, i2, arr) => "/" + arr.slice(0, i2 + 1).join("/"));
    const breadcrumbs = segments.map((path) => ({
      path,
      node: routes[path]
    })).filter((b) => b.node);
    return {
      segments,
      crumbs: breadcrumbs
    };
  }, [location2]);
  return result;
}
const ORIGINAL_TITLE = document.title;
function useDocumentTitle() {
  const { crumbs } = useBreadcrumbs();
  const appCtx = useAppContext();
  y(() => {
  }, []);
  y(() => {
    if (crumbs.length > 0) {
      document.title = ORIGINAL_TITLE + " | " + crumbs[crumbs.length - 1].node.label;
      if (appCtx.rootRef.current) {
        const page = appCtx.rootRef.current.querySelector('[data-route-page="node-detailed-page"]');
        if (page) {
          const isTopVisible = page.getBoundingClientRect().top >= 0;
          if (!isTopVisible) {
            page.scrollIntoView({ behavior: "smooth", block: "start" });
          }
        }
      }
    } else {
      document.title = ORIGINAL_TITLE;
    }
  }, [crumbs]);
}
function DocumentTitleUpdater() {
  useDocumentTitle();
  return null;
}
function Breadcrumbs() {
  const { crumbs } = useBreadcrumbs();
  return /* @__PURE__ */ u$1(
    "nav",
    {
      class: "tw:text-base tw:mb-4 tw:relative tw:overflow-x-auto",
      "aria-label": "Breadcrumb",
      "data-h-scroll-breadcrumb": true,
      children: /* @__PURE__ */ u$1("ol", { class: "tw:relative tw:whitespace-nowrap tw:overflow-x-auto  tw:inline-flex tw:space-x-2 tw:list-none tw:p-0 tw:mx-0 tw:my-2", children: [
        /* @__PURE__ */ u$1("li", { children: /* @__PURE__ */ u$1(Link, { href: "#/", class: "tw:text-gray-700 tw:hover:underline", children: "Home" }) }),
        crumbs.map(({ path, node }, idx) => /* @__PURE__ */ u$1("li", { class: "tw:flex tw:items-center", children: [
          /* @__PURE__ */ u$1("span", { class: "tw:mx-2", children: "/" }),
          idx === crumbs.length - 1 ? /* @__PURE__ */ u$1("span", { class: "tw:text-gray-500", children: node.label }) : /* @__PURE__ */ u$1(Link, { href: node._pathname, class: "tw:text-gray-700 tw:hover:underline", children: node.label })
        ] }, node._pathname))
      ] })
    }
  );
}
function Nav({ data }) {
  return /* @__PURE__ */ u$1("div", { className: "header-wrapper tw:min-w-0", children: [
    /* @__PURE__ */ u$1(DesktopNav, { data }),
    /* @__PURE__ */ u$1(MobileNav, { data })
  ] });
}
function DesktopNav({ data }) {
  return /* @__PURE__ */ u$1("div", { class: "tw:hidden tw:md:block tw:bg-white tw:isolate tw:relative tw:z-1 page-width", children: /* @__PURE__ */ u$1("custom-nav", { class: "tw:flex tw:items-center tw:justify-center", children: /* @__PURE__ */ u$1("ul", { class: "list-menu list-menu--inline ", role: "list", children: data.map((item, idx) => {
    const elementId = `Custom-MegaMenu-Content-${idx}`;
    const hasChildren = item.children && item.children.length > 0;
    const gridCols = !item.img ? "1fr" : "4fr 2fr";
    const LinkComponent = hasChildren ? Link : Link;
    return /* @__PURE__ */ u$1("li", { children: /* @__PURE__ */ u$1("header-menu", { class: "block", style: "--header-zindex: 0; --link-end: 125px;", children: /* @__PURE__ */ u$1("details", { id: elementId + "-details", class: "mega-menu", children: [
      /* @__PURE__ */ u$1(
        "summary",
        {
          id: elementId + "-summary",
          class: "header__menu-item list-menu__item link focus-inset",
          role: "button",
          "aria-expanded": "false",
          "aria-controls": elementId,
          children: [
            /* @__PURE__ */ u$1(
              LinkComponent,
              {
                href: item._pathname,
                class: "header__summary-link header__active-menu-item t2 font-bold",
                children: item.label
              }
            ),
            /* @__PURE__ */ u$1(
              "svg",
              {
                xmlns: "http://www.w3.org/2000/svg",
                "aria-hidden": "true",
                focusable: "false",
                class: "icon icon-caret",
                viewBox: "0 0 512 512",
                children: /* @__PURE__ */ u$1(
                  "path",
                  {
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    d: "M112 184l144 144 144-144",
                    "stroke-width": "48"
                  }
                )
              }
            )
          ]
        }
      ),
      item.children && item.children.length > 0 && /* @__PURE__ */ u$1(
        "div",
        {
          id: elementId + "-megamenu",
          class: "mega-menu__content color-scheme-1 custom-scrollbar gradient motion-reduce global-settings-popup",
          tabIndex: -1,
          children: /* @__PURE__ */ u$1("div", { class: "page-width", children: /* @__PURE__ */ u$1("div", { class: "mega-menu__grid", style: `grid-template-columns: ${gridCols}`, children: [
            /* @__PURE__ */ u$1("div", { children: /* @__PURE__ */ u$1(
              "ul",
              {
                class: "mega-menu__list p-0 t3",
                style: `--mega-menu-columns: ${item.children.length === 4 ? 2 : Math.min(3, item.children.length)};`,
                role: "list",
                children: item.children.map((subItem) => {
                  return /* @__PURE__ */ u$1("li", { children: [
                    /* @__PURE__ */ u$1(
                      Link,
                      {
                        href: subItem._pathname,
                        class: `mega-menu__link  link ${subItem.children && subItem.children.length > 0 ? "mega-menu__link--level-2" : "mega-menu__link--level-2"}`,
                        children: subItem.label
                      }
                    ),
                    subItem.children && subItem.children.length > 0 && /* @__PURE__ */ u$1("ul", { class: "list-unstyled", role: "list", children: subItem.children.map((subSubItem) => {
                      return /* @__PURE__ */ u$1("li", { children: /* @__PURE__ */ u$1(
                        Link,
                        {
                          href: subSubItem._pathname,
                          class: "mega-menu__link link",
                          children: subSubItem.label
                        }
                      ) });
                    }) })
                  ] });
                })
              }
            ) }),
            item.img && /* @__PURE__ */ u$1("div", { class: "mega-promos mega-promos--text_promo mega_promos--separator mega_promos--separator-right flex flex-col", children: /* @__PURE__ */ u$1(
              "div",
              {
                class: "promo-card--grid h-full",
                style: "grid-template-columns: repeat(1, minmax(0, 1fr));",
                children: /* @__PURE__ */ u$1(
                  "div",
                  {
                    class: "promo-card promo-card--text w-full h-full",
                    style: "--ratio-percent: 42.91845493562232%;--color-accent: var(--color-foreground);",
                    children: /* @__PURE__ */ u$1(
                      Link,
                      {
                        href: item._pathname,
                        class: "promo-card--text-container w-full h-full",
                        children: /* @__PURE__ */ u$1("div", { class: "w-full h-full", children: /* @__PURE__ */ u$1("div", { class: "mb-15 last-child:mb-0 h-full", children: /* @__PURE__ */ u$1("div", { class: "image-overlay promo-image overflow-hidden  hover-zoom ratio h-full", children: /* @__PURE__ */ u$1(
                          "img",
                          {
                            class: "promo-image img-cover tw:object-contain! h-full",
                            src: item.img,
                            style: "object-position: 50.0% 50.0%",
                            alt: "",
                            loading: "lazy",
                            fetchpriority: "low",
                            width: "540",
                            height: "150"
                          }
                        ) }) }) })
                      }
                    )
                  }
                )
              }
            ) })
          ] }) })
        }
      )
    ] }) }) });
  }) }) }) });
}
function MobileNav({ data }) {
  return /* @__PURE__ */ u$1("div", { class: "tw:block tw:md:hidden", children: /* @__PURE__ */ u$1("div", { class: "header-drawer-styles tw:inline!", children: /* @__PURE__ */ u$1("ul", { class: "menu-drawer__menu list-menu", role: "list", tabindex: -1, children: data.map((item, idx) => {
    const elementId = `CustomNavMobile-${idx}`;
    if (!item.children || item.children.length === 0) {
      return /* @__PURE__ */ u$1("li", { children: /* @__PURE__ */ u$1(
        Link,
        {
          href: item._pathname,
          class: "menu-drawer__menu-item menu__menu-item-title link link--text list-menu__item focus-inset",
          children: /* @__PURE__ */ u$1("span", { children: item.label })
        }
      ) });
    }
    return /* @__PURE__ */ u$1("li", { children: /* @__PURE__ */ u$1("custom-accordion", { children: /* @__PURE__ */ u$1("details", { id: elementId + "-accordion-details", class: "menu-opening", children: [
      /* @__PURE__ */ u$1(
        "summary",
        {
          id: elementId + "-accordion-summary",
          class: "menu-drawer__menu-item menu-drawer__child-menu-item link link--text list-menu__item focus-inset",
          role: "button",
          "aria-expanded": "true",
          "aria-controls": elementId,
          children: [
            /* @__PURE__ */ u$1("span", { children: item.label }),
            /* @__PURE__ */ u$1(
              "svg",
              {
                xmlns: "http://www.w3.org/2000/svg",
                "aria-hidden": "true",
                focusable: "false",
                class: "icon icon-caret",
                viewBox: "0 0 512 512",
                children: /* @__PURE__ */ u$1(
                  "path",
                  {
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    d: "M112 184l144 144 144-144",
                    "stroke-width": "48"
                  }
                )
              }
            )
          ]
        }
      ),
      /* @__PURE__ */ u$1(
        "div",
        {
          id: elementId,
          class: "custom-accordion__panel custom-scrollbar has-submenu gradient motion-reduce tw:duration-100",
          children: /* @__PURE__ */ u$1(
            "ul",
            {
              class: "menu-drawer__menu list-menu tw:ml-2! tw:pb-4!",
              role: "list",
              tabindex: -1,
              children: item.children.map((subItem) => {
                const hasChildren = subItem.children && subItem.children.length > 0;
                return /* @__PURE__ */ u$1("li", { children: [
                  /* @__PURE__ */ u$1(
                    Link,
                    {
                      href: subItem._pathname,
                      class: `menu-drawer__menu-item link link--text list-menu__item focus-inset tw:mb-0! ${!hasChildren ? "tw:text-[90%]! tw:opacity-80 tw:py-1!" : ""}`,
                      children: /* @__PURE__ */ u$1("span", { class: "tw:underline", children: subItem.label })
                    }
                  ),
                  hasChildren && /* @__PURE__ */ u$1(
                    "ul",
                    {
                      class: "menu-drawer__menu list-menu tw:ml-2!",
                      role: "list",
                      tabindex: -1,
                      children: subItem.children?.map((subSubItem) => {
                        return /* @__PURE__ */ u$1("li", { children: /* @__PURE__ */ u$1(
                          Link,
                          {
                            href: subSubItem._pathname,
                            class: "menu-drawer__menu-item link link--text list-menu__item focus-inset tw:mb-0! tw:text-[90%]! tw:opacity-80 tw:py-1!",
                            children: /* @__PURE__ */ u$1("span", { class: "tw:underline", children: subSubItem.label })
                          }
                        ) });
                      })
                    }
                  )
                ] });
              })
            }
          )
        }
      )
    ] }) }) });
  }) }) }) });
}
function ItemCards({ node }) {
  const list = Array.isArray(node) ? node : node.children;
  if (!list || list.length === 0) return null;
  const id = g();
  return /* @__PURE__ */ u$1("slider-component", { class: "slider-mobile-gutter page-width-desktop", children: /* @__PURE__ */ u$1(
    "ul",
    {
      id: `Slider-template-${id}`,
      class: "multicolumn-list contains-content-container section-grid grid mb-0 grid--3-col-desktop grid--1-col-tablet-down grid--1-col-tablet-down-strict",
      role: "list",
      tabIndex: 0,
      "aria-label": "Slider",
      style: "--mobile-height: 60px; --desktop-height: 30px",
      children: list.map((node2) => {
        return /* @__PURE__ */ u$1(ItemCard, { node: node2 });
      })
    }
  ) });
}
function ItemCard({ node }) {
  return /* @__PURE__ */ u$1("li", { class: "multicolumn-list__item grid__item text-left section-height-responsive--desktop section-height-responsive--mobile color-schemes--different", children: /* @__PURE__ */ u$1(
    "div",
    {
      class: "multicolumn-card responsive-card-padding overflow-hidden h-full flex flex-col content-container color-scheme-10 gradient flex items-left flex-col",
      style: "--responsive-card-padding: 3rem",
      children: [
        /* @__PURE__ */ u$1(
          "div",
          {
            class: "multicolumn-card__image-wrapper multicolumn-card__image-wrapper-full w-full tw:relative",
            hidden: !node.img,
            children: [
              /* @__PURE__ */ u$1("div", { class: "inline-block w-full", children: /* @__PURE__ */ u$1("div", { class: "media media--transparent media--landscape_widez media--square", children: /* @__PURE__ */ u$1(
                "img",
                {
                  src: node.img || "",
                  alt: "",
                  width: "3200",
                  height: "2076",
                  sizes: "\n          (min-width: 1400px) calc((1400px - 132px) * 2 /  3),\n          (min-width: 990px) calc((100vw - 132px) * 2 / 5),\n          (min-width: 750px) calc((100vw - 100px) * 2 / 7),\n          calc((100vw - 60px) / 1.5)\n        ",
                  class: "multicolumn-card__image tw:bg-white tw:object-contain! tw:border tw:border-b-0 tw:border-gray-100",
                  fetchpriority: "low"
                }
              ) }) }),
              /* @__PURE__ */ u$1(
                Link,
                {
                  href: node._pathname,
                  class: "tw:absolute tw:top-0 tw:left-0 tw:w-full tw:h-full",
                  tabIndex: -1,
                  children: /* @__PURE__ */ u$1("span", {})
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ u$1("div", { class: "multicolumn-card__info card-padding relative grow flex flex-col justify-start w-full", children: [
          /* @__PURE__ */ u$1("h3", { class: "multicolumn-card__heading lh-13 mt-05 mb-1 last-child:mb-0 inline-richtext h4", children: /* @__PURE__ */ u$1(Link, { class: "tw:no-underline", href: node._pathname, tabIndex: -1, children: node.label }) }),
          /* @__PURE__ */ u$1("div", { class: "multicolumn-card__text text-balance rte t5", children: /* @__PURE__ */ u$1("p", { children: node.description }) }),
          /* @__PURE__ */ u$1("div", { class: "banner__buttons--multiple h-full tw:flex tw:items-end", children: /* @__PURE__ */ u$1(
            Link,
            {
              href: node._pathname,
              class: "mt-2 t6 button button--primary button-with-icon button-with-icon--right",
              children: [
                "Learn More",
                /* @__PURE__ */ u$1(
                  "svg",
                  {
                    xmlns: "http://www.w3.org/2000/svg",
                    fill: "none",
                    focusable: "false",
                    class: "icon icon-arrow",
                    viewBox: "0 0 512 512",
                    children: /* @__PURE__ */ u$1(
                      "path",
                      {
                        fill: "none",
                        stroke: "currentColor",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        d: "M268 112l144 144-144 144M392 256H100",
                        class: "stroke-width-standard"
                      }
                    )
                  }
                )
              ]
            }
          ) })
        ] })
      ]
    }
  ) });
}
function treeToObject(nodes, makeKey, parentKey = "") {
  const result = {};
  nodes.forEach((node, idx) => {
    const key = makeKey(node, idx, parentKey);
    result[key] = node;
    if (node.children && node.children.length > 0) {
      const children = treeToObject(node.children, makeKey, key);
      Object.assign(result, children);
    }
  });
  return result;
}
function slugify(text) {
  return text.toLowerCase().replace(/[^\w]+/g, "-").replace(/^-+/, "").replace(/-+$/, "").trim();
}
function Component(props) {
  const { data } = props;
  const selfRef = A(null);
  const rootRef = A(null);
  const routes = T(
    () => treeToObject(data, (node, idx, parentPath = "") => {
      const slug = slugify(node.label);
      const path = `${parentPath}/${slug}`;
      node._pathname = path;
      return path;
    }),
    [data]
  );
  const providerValue = T(() => ({ data, routes, rootRef }), [data, routes]);
  y(() => {
    if (selfRef.current) {
      const parent = selfRef.current.closest("x-gsp-products-center");
      rootRef.current = parent || null;
      if (parent) {
        parent.__preact_app_context = providerValue;
      }
    }
  }, [providerValue]);
  return /* @__PURE__ */ u$1(AppContextProvider, { value: providerValue, children: /* @__PURE__ */ u$1("div", { class: "tailwindcss", ref: selfRef, children: /* @__PURE__ */ u$1("div", { class: "tw:grid tw:gap-8 tw:md:gap-16", children: /* @__PURE__ */ u$1(Router, { hook: useHashLocation, children: [
    /* @__PURE__ */ u$1(DocumentTitleUpdater, {}),
    /* @__PURE__ */ u$1(Route, { children: /* @__PURE__ */ u$1("div", { class: "tw:min-w-0", children: /* @__PURE__ */ u$1(Nav, { data }) }) }),
    /* @__PURE__ */ u$1(Switch, { children: [
      Object.entries(routes).map(([path, node]) => /* @__PURE__ */ u$1(Route, { path, children: /* @__PURE__ */ u$1("div", { class: "page-width", children: /* @__PURE__ */ u$1(NodeDetailedPage, { node }) }) }, path)),
      /* @__PURE__ */ u$1(Route, { children: [
        /* @__PURE__ */ u$1("h2", { class: "tw:text-center tw:text-theme-primary!", children: "Products Line" }),
        /* @__PURE__ */ u$1(ItemCards, { node: data })
      ] })
    ] })
  ] }) }) }) });
}
function NodeDetailedPage({ node }) {
  return /* @__PURE__ */ u$1("div", { class: "tw:grid tw:gap-8 tw:md:gap-16", "data-route-page": "node-detailed-page", children: [
    /* @__PURE__ */ u$1("div", { class: "tw:min-w-0", children: /* @__PURE__ */ u$1(Breadcrumbs, {}) }),
    /* @__PURE__ */ u$1("div", { children: /* @__PURE__ */ u$1("div", { class: "tw:grid tw:grid-cols-1 tw:md:grid-cols-2 tw:gap-8 tw:md:gap-16", children: [
      /* @__PURE__ */ u$1("div", { class: "tw:grid tw:place-content-center", children: node.img && /* @__PURE__ */ u$1("img", { class: "tw:max-w-full", src: node.img }) }),
      /* @__PURE__ */ u$1("div", { children: [
        /* @__PURE__ */ u$1("h2", { class: "tw:text-theme-primary!", children: node.label }),
        /* @__PURE__ */ u$1("p", { children: node.description }),
        node.html && /* @__PURE__ */ u$1("div", { class: "tw:whitespace-pre-line", children: node.html })
      ] })
    ] }) }),
    node && node.children && node.children.length > 0 && /* @__PURE__ */ u$1("div", { children: [
      /* @__PURE__ */ u$1("h2", { class: "tw:text-theme-primary! tw:text-center", children: node._depth === 0 ? "Product Offering" : `${node.label} Products` }),
      /* @__PURE__ */ u$1(ItemCards, { node })
    ] })
  ] });
}
function validateProps(props) {
  if (!props) return false;
  if (!props.data || !Array.isArray(props.data) || !props.data.length)
    throw new WidgetError("Missing or invalid data");
  function walker(node, depth = 0) {
    if (!node) throw new WidgetError("Empty node found");
    if (!node.label || typeof node.label !== "string") throw new WidgetError("Invalid label");
    if (!node.link || typeof node.link !== "string") throw new WidgetError("Invalid link");
    if (node.img && typeof node.img !== "string") throw new WidgetError("Invalid image");
    if (node.description && typeof node.description !== "string")
      throw new WidgetError("Invalid description");
    if (node.html && typeof node.html !== "string") throw new WidgetError("Invalid html");
    if (node.children && !Array.isArray(node.children)) throw new WidgetError("Invalid children");
    node._depth = depth;
    if (node.children && node.children.length > 0) {
      for (let i2 = 0; i2 < node.children.length; i2++) {
        const child = node.children[i2];
        walker(child, depth + 1);
      }
    }
  }
  for (let i2 = 0; i2 < props.data.length; i2++) {
    const child = props.data[i2];
    walker(child, 0);
  }
  return true;
}
class XGspProductsCenter extends HTMLElement {
  static tag = "x-gsp-products-center";
  #props;
  appInstance;
  _connected;
  constructor() {
    super();
    this.#props = null;
    this.appInstance = null;
    this._connected = false;
  }
  async connectedCallback() {
    this._connected = true;
    await Promise.resolve();
    if (!this._connected) return;
    this.mount();
  }
  async disconnectedCallback() {
    this._connected = false;
    await Promise.resolve();
    if (this._connected) return;
    this.unmount();
  }
  get props() {
    if (this.#props) return this.#props;
    let data = null;
    const scriptEl = this.querySelector('script[data-component-props][type="application/json"]');
    if (!scriptEl) {
      throw new Error(
        `[${XGspProductsCenter.tag}] Missing <script type="application/json" data-component-props>...<\/script> element`
      );
    }
    try {
      data = JSON.parse(scriptEl.textContent || "null");
    } catch (e2) {
      data = null;
    }
    if (!data) {
      throw new Error(`[${XGspProductsCenter.tag}] Invalid or missing data. Error parsing`);
    }
    if (!validateProps(data)) {
      throw new Error(`[${XGspProductsCenter.tag}] Invalid props`);
    }
    this.#props = data;
    return this.#props;
  }
  mount() {
    const props = this.props;
    const app = G(/* @__PURE__ */ u$1(Component, { ...props }), this);
    this.appInstance = app;
  }
  unmount() {
    G(null, this);
    this.appInstance = null;
  }
}
if (!customElements.get(XGspProductsCenter.tag)) {
  customElements.define(XGspProductsCenter.tag, XGspProductsCenter);
}

})();